/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_ARTISTS = createAsyncAction('GET_ARTISTS')
export const getSpotifyArtists = (url, token, callback) =>
  apiCall({
    method: 'get',
    endpoint: url,
    headers: { Authorization: `Bearer ${token}` },
    types: GET_ARTISTS,
    callback,
  })

export const GET_ARTIST_GENRES = createAsyncAction('GET_ARTIST_GENRES')
export const getArtistGenres = (id, callback) =>
  apiCall({
    method: 'get',
    endpoint: `/campaign/spotify-artist-genres/${id}/with_playlists`,
    types: GET_ARTIST_GENRES,
    callback,
  })
